import PageWrapper from '@/shared/components/PageWrapper/PageWrapper';
import { withTranslation } from 'react-i18next';

const ErrorPage404: React.FC = () => {
  return (
    <PageWrapper name="error-page" noHeader={true}>
      <h1>404 PAGE NOT FOUND</h1>
    </PageWrapper>
  );
};

export default withTranslation()(ErrorPage404);
